import React from 'react';
import Slider from "react-slick";
import '../styles/components/carousal.scss'

const Carousel = (props) => {
    const data = props.data;
    var settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive:[
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2, 
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1, 
                }
            }
        ]      
    }; 
    return (
        <div className="carousal">
            <div className="innerBox">
                {data.subheading && 
                    <h4 className="sectionSubHeading">{data.subheading}</h4>
                }
                {data.title && 
                    <h3 className="sectionHeading">{data.title}</h3>
                }
                <Slider {...settings}>
                    {data.images.map((d,i) =>
                        <div key={i}><img src={d} alt={data.title} /></div>
                    )}                                           
                </Slider>
            </div>
        </div>
    );
}

export default Carousel;